// storage.js
const STORAGE_KEY = "osailuAppSettings";

export function getSettings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setSettings(value) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
}

export function clearSettings() {
  localStorage.removeItem(STORAGE_KEY);
}
